<template>
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ic_refund">
      <g id="Group 8043">
        <g id="Group 8042">
          <circle
            id="Ellipse 388"
            cx="31.3883"
            cy="50.2645"
            r="20.7918"
            fill="white"
            stroke="#4D4E58"
            stroke-width="2.80702"
          />
          <circle
            id="Ellipse 387"
            cx="37.0026"
            cy="47.4594"
            r="20.7918"
            fill="white"
            stroke="#4D4E58"
            stroke-width="2.80702"
          />
          <circle
            id="Ellipse 385"
            cx="43.6134"
            cy="43.8973"
            r="20.7918"
            fill="white"
            stroke="#4D4E58"
            stroke-width="2.80702"
          />
          <path
            id="Ellipse 386"
            d="M31.2708 31.9726C29.7444 33.499 28.5413 35.3188 27.7302 37.3281C26.9191 39.3374 26.5159 41.4969 26.5435 43.6832C26.5712 45.8695 27.0293 48.0399 27.8915 50.0704C28.7537 52.1009 30.0033 53.9518 31.5688 55.5173C33.1344 57.0829 34.9852 58.3324 37.0157 59.1947C39.0462 60.0569 41.2166 60.5149 43.4029 60.5426C45.5893 60.5703 47.7487 60.1671 49.7581 59.3559C51.7674 58.5448 53.5872 57.3417 55.1136 55.8153L43.1922 43.894L31.2708 31.9726Z"
            fill="#E0E5FF"
          />
        </g>
        <g id="Group 8044">
          <path
            id="Vector 458"
            d="M35.8101 39.2347L39.6539 49.5811C39.7461 49.8293 40.0993 49.8235 40.1833 49.5723L43.3736 40.0309C43.459 39.7753 43.8206 39.7753 43.906 40.0309L47.0963 49.5723C47.1803 49.8235 47.5335 49.8293 47.6257 49.5811L51.4695 39.2347"
            stroke="#4D4E58"
            stroke-width="2.45614"
            stroke-linecap="round"
          />
          <path
            id="Vector 459"
            d="M35.1577 43.1484H52.1222"
            stroke="#4D4E58"
            stroke-width="2.45614"
            stroke-linecap="round"
          />
        </g>
      </g>
      <g id="Group 8843">
        <path
          id="Vector 471"
          d="M44.4565 10.5255V14.0343"
          stroke="#7B90FF"
          stroke-width="4.21053"
          stroke-linecap="round"
        />
        <path
          id="Vector 472"
          d="M57.9648 14.0337L56.2105 17.0724"
          stroke="#7B90FF"
          stroke-width="4.21053"
          stroke-linecap="round"
        />
        <path
          id="Vector 474"
          d="M66.9688 22.4563L63.9301 24.2107"
          stroke="#7B90FF"
          stroke-width="4.21053"
          stroke-linecap="round"
        />
        <path
          id="Vector 473"
          d="M30.9473 14.0337L32.7017 17.0724"
          stroke="#7B90FF"
          stroke-width="4.21053"
          stroke-linecap="round"
        />
        <path
          id="Vector 475"
          d="M21.8843 22.4563L24.923 24.2107"
          stroke="#7B90FF"
          stroke-width="4.21053"
          stroke-linecap="round"
        />
      </g>
    </g>
  </svg>
</template>
